import React, { useCallback, useState, useRef, useEffect, useContext } from 'react'
import { createPortal } from 'react-dom'
import styled from 'styled-components'
import Button from '../components/Button'
import { FormattedHTMLMessage } from 'react-intl'
import useNextPage from './useNextPage'
import { courseStore } from '../state/courseStore'
import { pageStore } from '../state/pagestore'
const Response = ({
  children,
  isOpen = false,
  close,
  elementId = 'root',
  wrapperRef,
  maskColor
}) => {
  if (isOpen === false) {
    return null
  }

  return createPortal(
    <Wrapper ref={wrapperRef} maskColor={maskColor}>
      <Container className='content'>{children}</Container>
    </Wrapper>,
    document.getElementById(elementId)
  )
}
const useResponse = (elementId = 'root', pagingInfo, resetTask) => {
  const [isOpen, setOpen] = useState(false)
  const [handleNextPage] = useNextPage({ ...pagingInfo })
  const { state: courseState, dispatch: courseDispatch } = useContext(courseStore)
  const { dispatch: pageDispatch } = useContext(pageStore)
  const wrapperRef = useRef()
  const open = useCallback(() => {
    setOpen(true)
    toggleSkip(false)
    // eslint-disable-next-line
  }, [setOpen])

  const close = useCallback(() => {
    setOpen(false)
    toggleSkip(true)
    // eslint-disable-next-line
  }, [setOpen])

  const toggleSkip = (toggle) => {
    pageDispatch({
      type: 'toggle-skip',
      toggle
    })
  }

  const completeTask = () => {
    courseDispatch({
      type: 'completed-task',
      pageID: pagingInfo.pageID,
      levelID: pagingInfo.levelID
    })
  }

  useEffect(() => {
    setTimeout(() => window.scroll({ top: document.getElementById('root').clientHeight + wrapperRef.current?.clientHeight, behavior: 'smooth' }), 300)
  }, [isOpen])
  const resetPage = () => {
    // window.location.reload(false)
    resetTask()
    toggleSkip(true)
  }
  const ResponseWrapper = useCallback(
    ({ maskColor = 'transparent', textID, reset }) => {
      return (
        <Response
          isOpen={isOpen}
          elementId={elementId}
          wrapperRef={wrapperRef}
          maskColor={maskColor}

        >
          <p className='feedback'>
            <FormattedHTMLMessage
              id={textID}
            />
          </p>
          <StyledLinkWrapper>
            {maskColor === 'wrong' && <Button handleClick={() => resetPage()} text='retryLabel' classes={['continue']} />}
            {maskColor === 'wrong' && courseState.allowSkip &&
              <Button
                handleClick={handleNextPage}
                classes={['continue']}
                text='skipLabel'
                tabIndex={100}
              />}
            {maskColor === 'right' &&
              <Button
                handleClick={handleNextPage}
                classes={['continue']}
                text='continueLabel'
                tabIndex={100}
              />}
          </StyledLinkWrapper>
        </Response>
      )
    },
    // eslint-disable-next-line
    [isOpen, elementId, handleNextPage]
  )

  return [ResponseWrapper, open, close, isOpen, completeTask]
}

const Wrapper = styled.div`
display: flex;
flex-direction: column;
align-items: center;
width: 100%;
background-color: ${({ maskColor, theme }) => theme.colors[maskColor]};
min-height: 15rem;
font-weight: 300;
.feedback > span {
  color: white;
  font-size: 1.3em;
}
.feedback {
  margin-bottom: 2rem;
  text-align: center;
}
`

const StyledLinkWrapper = styled.div`
  display: flex;
  > button:nth-child(2) {
    margin-left: 1rem;
  }
`

const Container = styled.div`
padding: 2rem;
max-width: 1024px;
display: flex;
flex-direction: column;
align-items: center;
*:focus {
  outline-color: #fdfdfd!important;
}
`

export default useResponse
